import { createContext, Context } from "react"

/* eslint-disable @typescript-eslint/no-empty-interface */

export interface RoadsideContextFilters {
    conditions?: number[],
    tags?: string[],
    type?: string,
}

export interface RoadsideContextState {
    ascendantCodes: string[],
    descendantCodes: string[],
    filters: RoadsideContextFilters,
}

export interface RoadsideContextDispatch {
    setFilters?: (filters: any) => void,
}

export const initialState: RoadsideContextState = {
    ascendantCodes: [],
    descendantCodes: [],
    filters: {},
}

export const RoadsideStateContext: Context<RoadsideContextState> = createContext<RoadsideContextState>(initialState)
export const RoadsideDispatchContext: Context<RoadsideContextDispatch> = createContext<RoadsideContextDispatch>({})

